import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Snackbar } from '@/shared/components/Snackbar';

type RouteFlashSnackbarProps = {
  stateKey: string;
};

const RouteFlashSnackbar = ({ stateKey }: RouteFlashSnackbarProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const state = (location.state as Record<string, unknown> | null) ?? null;
    const routeMessage = state?.[stateKey];

    if (typeof routeMessage !== 'string' || !routeMessage) {
      return;
    }

    setMessage(routeMessage);
    setIsOpen(true);

    const nextState = { ...state };
    delete nextState[stateKey];

    navigate(`${location.pathname}${location.search}${location.hash}`, {
      replace: true,
      state: Object.keys(nextState).length > 0 ? nextState : null,
    });
  }, [
    location.hash,
    location.pathname,
    location.search,
    location.state,
    navigate,
    stateKey,
  ]);

  return (
    <Snackbar
      open={isOpen}
      message={message}
      variant="success"
      onClose={() => setIsOpen(false)}
      autoHideDuration={5000}
      position="top-center"
      showCloseButton
    />
  );
};

export default RouteFlashSnackbar;
